export type SignupRequest = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    password: string;
};

export type SignupFormData = SignupRequest & {
    passwordAgain: string;
};

export function createSignupRequestFromFormData(
    formData: SignupFormData,
): SignupRequest {
    const { firstName, lastName, email, phone, password } = formData;

    return { firstName, lastName, email, phone, password };
}
